(() => {
  const carousels = document.querySelectorAll('[data-cr-carousel]');

  carousels.forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';

    const slides = Array.from(carousel.querySelectorAll('[data-cr-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-cr-dot]'));
    const previous = carousel.querySelector('[data-cr-prev]');
    const next = carousel.querySelector('[data-cr-next]');
    const status = carousel.querySelector('[data-cr-carousel-status]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;
    let pointerStartX = null;

    if (slides.length < 2) return;

    const setInteractive = (slide, enabled) => {
      slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        if (enabled) element.removeAttribute('tabindex');
        else element.setAttribute('tabindex', '-1');
      });
    };

    const show = (index, announce = true) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        setInteractive(slide, active);
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (announce && status) status.textContent = `Promotion ${activeIndex + 1} of ${slides.length}`;
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (!reduceMotion && !document.hidden) {
        timer = window.setInterval(() => show(activeIndex + 1, false), 6500);
      }
    };

    previous?.addEventListener('click', () => { show(activeIndex - 1); start(); });
    next?.addEventListener('click', () => { show(activeIndex + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) start();
    });
    carousel.addEventListener('pointerdown', (event) => { pointerStartX = event.clientX; });
    carousel.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) > 50) {
        show(activeIndex + (distance < 0 ? 1 : -1));
        start();
      }
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });

    show(0, false);
    start();
  });
})();
